// @core/api/endpoints/form/get_form_template.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  FormTemplateResponse,
} from '../../../types/form';

const BASE_PATH = '/form';

/**
 * Get form template
 * Retrieves a form template by its unique identifier.
 */
export async function GetFormTemplate(
  template_id: string,
  options?: RequestOptions
): Promise<FormTemplateResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/forms/templates/:template_id`;
  requestPath = requestPath.replace(':template_id', encodeURIComponent(template_id));
  const requestOptions = options;
  return client.get<FormTemplateResponse>(requestPath, { ...requestOptions });
}
